// ContinuityControl — a disabled "em breve" placeholder for the future
// cross-section continuity feature (spec 2026-05-20-section-as-generation-unit-design.md §6).
//
// Each section is currently generated as an INDEPENDENT clip — there is no
// conditioning between neighbouring sections. This control is the UI seam: it
// is always `disabled` and dispatches nothing (no store action, no API call,
// no state mutation). When the continuity feature lands, it only needs to drop
// `disabled` and wire an `onChange`; nothing else here is load-bearing.

const TOOLTIP =
  "Cada seção é gerada como um clipe independente por enquanto — " +
  "o condicionamento entre seções vem numa próxima versão.";

export function ContinuityControl(): JSX.Element {
  return (
    <div
      className="flex items-center gap-2.5 opacity-50"
      title={TOOLTIP}
      aria-disabled="true"
      data-testid="continuity-control"
    >
      <span className="font-mono text-[10px] uppercase tracking-widest2 text-ink-dim">
        Continuidade entre seções
      </span>
      {/* Inert track + knob, parked in the "off" position. Purely decorative —
          a real <button role="switch"> would still be focusable; this is not. */}
      <span
        aria-hidden="true"
        className="relative inline-flex h-3.5 w-7 shrink-0 items-center border border-border bg-asphalt"
      >
        <span className="ml-0.5 h-2 w-2 bg-ink-dim" />
      </span>
      <span className="border border-border px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-widest2 text-ink-dim">
        em breve
      </span>
    </div>
  );
}
